import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "components/app/dialog/dialog";
import ImageUrl from "components/app/image-url/ImageUrl";
import ShopDetailUploadProfile from "components/app/upload-profile/ShopDetailUploadProfile";
import { Download, X } from "lucide-react";

interface DialogProps {
  onValueChange: (value: any) => void;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
  itemUserProfile: any;
}

export default function DialogClickShopProfilePicture({
  itemUserProfile,
  onValueChange,
  isDialogOpen,
  setIsDialogOpen,
}: DialogProps) {
  return (
    <Dialog open={isDialogOpen}>
      <DialogContent
        className="w-[400px] md:w-[600px] lg:w-[715px]"
        isShowBtnXClose={false}
      >
        <DialogHeader>
          <DialogTitle>Edit Profile Picture</DialogTitle>
          <DialogDescription>
            Make changes to your profile here. Click save when you're done.
          </DialogDescription>
          <div className="absolute right-14 top-1 flex items-center space-x-2">
            <div className="flex items-center justify-center z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px] p-1">
              <ShopDetailUploadProfile
                userShop={itemUserProfile}
                onUploadSuccess={(value: any) => onValueChange(value)}
              />
            </div>
          </div>

          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => setIsDialogOpen(false)}
          >
            <X />
          </div>
        </DialogHeader>
        <div className="w-full h-full">
          <ImageUrl
            src={itemUserProfile?.picture}
            className="w-full object-cover rounded-t-none sm:rounded-t-lg"
            alt="menu"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
